import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCreateLiveStreamRequestBody,
  IApiCreateLiveStreamResponseBody,
  IApiDeleteLiveStreamResponseBody,
  IApiGetLiveStreamsRequestBody,
  IApiGetLiveStreamsResponseBody,
  IApiRefreshLiveStreamResponseBody,
  IApiRequestDownloadLiveStreamResponseBody,
  IApiRequestDownloadLiveStreamsRequestParams,
  IApiUpdateLiveStreamRequestBody,
  IApiUpdateLiveStreamResponseBody,
} from './LiveStreamsApi.types';

export class LiveStreamsApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
    params?: IApiGetLiveStreamsRequestBody,
  ): Promise<IApiGetLiveStreamsResponseBody> {
    const request: IApiJsonRequest = {
      path: '/liveStream',
      method: 'get',
      params,
    };

    const response =
      await this.client.fetchJson<IApiGetLiveStreamsResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async get(
    appId: string,
    streamId: string,
  ): Promise<IApiRefreshLiveStreamResponseBody> {
    const request: IApiJsonRequest = {
      path: `/liveStream/${streamId}/refresh`,
      method: 'put',
    };

    const response =
      await this.client.fetchJson<IApiRefreshLiveStreamResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async create(
    appId: string,
    body: IApiCreateLiveStreamRequestBody,
  ): Promise<IApiCreateLiveStreamResponseBody> {
    const request: IApiJsonRequest = {
      path: '/liveStream',
      method: 'post',
      body,
    };

    const response =
      await this.client.fetchJson<IApiCreateLiveStreamResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async update(
    appId: string,
    liveStreamId: string,
    body: IApiUpdateLiveStreamRequestBody,
  ): Promise<IApiUpdateLiveStreamResponseBody> {
    const request: IApiJsonRequest = {
      path: `/liveStream/${liveStreamId}`,
      method: 'put',
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateLiveStreamResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async delete(
    appId: string,
    liveStreamId: string,
  ): Promise<IApiDeleteLiveStreamResponseBody> {
    const request: IApiJsonRequest = {
      path: `/liveStream/${liveStreamId}`,
      method: 'delete',
    };

    const response =
      await this.client.fetchJson<IApiDeleteLiveStreamResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async refresh(
    appId: string,
    liveStreamId: string,
  ): Promise<IApiRefreshLiveStreamResponseBody> {
    const request: IApiJsonRequest = {
      path: `/liveStream/${liveStreamId}/refresh`,
      method: 'put',
    };

    const response =
      await this.client.fetchJson<IApiRefreshLiveStreamResponseBody>(request, {
        appId,
      });

    return response.body;
  }

  public async requestDownload(
    appId: string,
    liveStreamId: string,
    params?: IApiRequestDownloadLiveStreamsRequestParams,
  ): Promise<IApiRequestDownloadLiveStreamResponseBody> {
    const request: IApiJsonRequest = {
      path: `/liveStream/${liveStreamId}/recordingConvert`,
      method: 'put',
      params,
    };

    const response =
      await this.client.fetchJson<IApiRequestDownloadLiveStreamResponseBody>(
        request,
        {
          appId,
        },
      );

    return response.body;
  }
}
